import axios from 'axios';
import {
  apiClientUrl,
} from '@/config';
import { jwtDecode } from 'jwt-decode';
import useUserStore from '@/stores/userStore';
// import useComponentStore from '@/stores/components';
// import router from '@/router';

export const apiClient = axios.create({
  baseURL: apiClientUrl,
  withCredentials: true,
});

apiClient.defaults.timeout = 1000 * 60 * 60;

// apiClient.interceptors.request.use(
//   async (config) => {
//     return config;
//   },
// );

const throttle = (callback, ms) => {
  let timeoutId = null;

  return (...args) => {
    if (timeoutId) {
      return;
    }

    timeoutId = window.setTimeout(() => {
      callback(args);

      window.clearTimeout(timeoutId);
      timeoutId = null;
    }, ms);
  };
};

const errors = [
  {
    status: 401,
    statusText: 'Unauthorized',
    async func() {
      // const { openAlertDialog } = useComponentStore();

      // await openAlertDialog({ content: 'login.authFail' });
      // router.push('/login');
    },
  },
  {
    status: 400,
    statusText: 'Bad Request',
    async func() {
      // const { openAlertDialog } = useComponentStore();

      // await openAlertDialog({ content: 'messageUsageJourney.wrongRequests' });
    },
  },
  {
    status: 403,
    statusText: 'Forbidden',
    async func() {
      // const { openAlertDialog } = useComponentStore();

      // await openAlertDialog({ content: 'common.globalError' });
    },
  },
  {
    status: 500,
    statusText: 'Internal Server Error',
    async func() {
      // const { openAlertDialog } = useComponentStore();

      // await openAlertDialog({ content: 'common.globalError' });
    },
  },
  {
    status: 'ERR_NETWORK',
    statusText: 'Network Error',
    async func() {
      // const { openAlertDialog } = useComponentStore();

      // await openAlertDialog({ content: 'common.globalError' });
    },
  },
];

const errorMap = { status: {}, statusText: {} };

errors.forEach(({ status, statusText, func }) => {
  const throttleFunc = throttle(func, 400);

  errorMap.status[status] = throttleFunc;
  errorMap.statusText[statusText] = throttleFunc;
});

const tokenRefresh = async (controller) => {
  const {
    setToken,
  } = useUserStore();

  try {
    const {
      data: {
        accessToken,
        idToken,
      },
    } = await axios.post(`${apiClientUrl}/token`, null, {
      withCredentials: true,
    });

    setToken({ accessToken, idToken });
    return accessToken;
  } catch {
    controller.abort();
    return '';
  }
};

apiClient.interceptors.request.use(async (config) => {
  const exceptionPathList = [
    '/accounts/login',
    '/token',
    '/accounts/find-id',
    '/password',
    '/password/mfa',
    '/password/verify',
  ];

  if (exceptionPathList.includes(config.url)) {
    return config;
  }

  let {
    state: {
      accessToken,
    },
  } = useUserStore();
  const {
    clear,
  } = useUserStore();
  const controller = new AbortController();
  const temp = config;

  try {
    const payload = jwtDecode(accessToken);
    const exp = payload?.exp ?? 0;

    if (exp < Date.now() / 1000) {
      clear();
      throw new Error('expired access token');
    }
  } catch {
    accessToken = await tokenRefresh(controller);
  } finally {
    temp.headers.Authorization = `Bearer ${accessToken}`;
  }

  temp.signal = controller.signal;

  return config;
}, (error) => Promise.reject(error));

apiClient.interceptors.response.use(
  (response) => {
    if (response.headers['content-disposition']) {
      return response;
    }

    return response.data;
  },
  (error) => {
    const status = error.response?.status ?? error.code;
    const statusText = error.response?.statusText;

    const temp = errorMap.status[status] ?? errorMap.statusText[statusText];

    if (typeof temp === 'function') {
      temp(error);
    }

    return Promise.reject(error);
  },
);

export const setAuthorization = ({ authorization }) => {
  apiClient.defaults.headers.common.Authorization = authorization ? `Bearer ${authorization}` : '';
};
